import React, { useCallback, useEffect } from 'react';
import { connect, Provider, useDispatch, useSelector } from 'react-redux';
import {
  closeOverlay as closeOverlayAction,
  removeOverlay as removeOverlayAction,
} from '../Actions/Overlay.action';

const OVERLAY_CLASS = 'overlay';

const OverlayContainer = () => {
  const dispatch = useDispatch();

  const { activeOverlays, disableOverlayClick } = useSelector(
    (state) => state.overlay
  );

  const closeOverlay = () => dispatch(closeOverlayAction());
  const removeOverlay = (componentName) =>
    dispatch(removeOverlayAction(componentName));

  const overlayClasses = activeOverlays
    ? [
        activeOverlays.length > 0 && OVERLAY_CLASS,
        ...activeOverlays.map((c) => `${OVERLAY_CLASS}--${c.name}`),
      ]
    : [];
  /**
   * Adds overlay classes to body to enable styling on components based on active overlays
   */
  useEffect(() => {
    // Remove all overlay classes that are not active anymore, before adding new
    const classesToRemove = Array.from(document.body.classList).filter(
      (c) => c.startsWith(OVERLAY_CLASS) || c == OVERLAY_CLASS
    );
    if (classesToRemove && classesToRemove.length > 0) {
      for (let className of classesToRemove) {
        document.body.classList.remove(className);
      }
    }

    // Add overlay classes to body
    if (activeOverlays && activeOverlays.length > 0) {
      for (let className of overlayClasses) {
        document.body.classList.add(className);
      }
    }
  }, [activeOverlays]);

  /**
   * Removes all overlays.
   * Triggers onOverLay click on all active overlay components
   */
  const onOverlayClick = useCallback(() => {
    if (disableOverlayClick) return;

    for (let component of activeOverlays) {
      if (component.onOverlayClick) {
        if (component.onOverlayClick() !== false) {
          removeOverlay(component.name);
        }
      }
    }
  }, [activeOverlays, disableOverlayClick]);

  return (
    activeOverlays &&
    activeOverlays.length > 0 && (
      <div className={overlayClasses.join(' ')} onClick={onOverlayClick}></div>
    )
  );
};

const mapStateToProps = (state) => {
  return {
    ...state.overlay,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    closeOverlay: dispatch(closeOverlay()),
    removeOverlay: (componentName) =>
      dispatch(removeOverlayAction(componentName)),
  };
};

export default OverlayContainer;
